export default "__VITE_ASSET__DSeJv3iI__"